import { type SideBySideConsultNoteCandidateWithStream } from '@/features/sideBySideNoteGen/types';
import { StreamingStatus } from '@/models/scribeRecordModel';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { GET_SESSION_BY_ID, type QuerySessionResponse } from '@heidi/session/contracts';
import { produce } from 'immer';

export function setConsultNoteFromCandidate(
  candidate: SideBySideConsultNoteCandidateWithStream,
  sessionId: string
) {
  // Extract the final result from the candidate's stream
  const finalResult = candidate.stream.map((chunk) => chunk.data).join('');

  // Update the session query data with the chosen candidate's result
  reactQueryClient.setQueryData<QuerySessionResponse>(
    [GET_SESSION_BY_ID, { sessionId }],
    (oldData) => {
      if (!oldData) return oldData;
      // Use immer produce to avoid large, complex and nested spread (...) logic
      return produce(oldData, (draft) => {
        draft.consult_note.result = finalResult;
        draft.streamingStatus = StreamingStatus.FINISHING_STREAMING;
      });
    }
  );
}
